import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.BankAccountCard', {
    bankAccountNumber: 'Account number',
    balance: 'Balance',
    currencyCode: 'Currency',
    disconnected: 'disconnected',
    iban: 'IBAN',
    sortCode: 'Sort code',
});
